"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateTruncatedPages = void 0;

var tslib_1 = require("tslib");

var generateTruncatedPages = function generateTruncatedPages(_a) {
  var truncateAt = _a.truncateAt,
      currentPage = _a.currentPage,
      totalPages = _a.totalPages;
  var displayNumber = truncateAt - 2;
  var range = Math.floor((displayNumber - 1) / 2);
  var center = currentPage;
  var withLeadingEllip = true;
  var withTrailingEllip = true; // Total number of pages is less that truncation limit.
  // 👉 Show all the pages.

  if (truncateAt - 2 >= totalPages - 2) {
    withLeadingEllip = false;
    withTrailingEllip = false;

    var _b = tslib_1.__read(Array.from(Array(totalPages - 1)).map(function (_, i) {
      return i + 1;
    })),
        _1 = _b[0],
        indices_1 = _b.slice(1);

    return {
      indices: indices_1,
      withTrailingEllip: withTrailingEllip,
      withLeadingEllip: withLeadingEllip
    };
  } // The current page is within range of the 1st page.
  // 👉 Show the first pages together then ellipsis and the last number.


  if (currentPage - Math.floor(displayNumber / 2) < displayNumber) {
    center = 2 + range;
    withLeadingEllip = false;
  } // The current page is within range of the last page.
  // 👉 Show the first page, then ellipsis and then last numbers together.


  if (totalPages - currentPage < displayNumber) {
    center = totalPages - 1 - range;
    withTrailingEllip = false;
  }

  var indices = Array.from(Array(displayNumber)).map(function (_, i) {
    return -range + i + center;
  });
  return {
    indices: indices,
    withTrailingEllip: withTrailingEllip,
    withLeadingEllip: withLeadingEllip
  };
};

exports.generateTruncatedPages = generateTruncatedPages;